import { CustomThemeContext, CustomThemeContextProps } from '@theme/CustomThemeProvider';
import { useContext } from 'react';

export interface UseCustomThemeContextData extends CustomThemeContextProps {}

const useCustomThemeContext = (): UseCustomThemeContextData => useContext(CustomThemeContext);

export default useCustomThemeContext;
